"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deserializeHxAttendeeAvailabilityData = void 0;
var HxAvailabilityEventData_1 = require("./HxAvailabilityEventData");
var HxWorkingHours_1 = require("./HxWorkingHours");
function deserializeHxAttendeeAvailabilityData(values) {
    var i = 0;
    var smtpAddress = values[i++];
    var responseCode = values[i++];
    var responseMessage = values[i++];
    var availabilityEventsValues = values[i++];
    var availabilityEvents = new Array(availabilityEventsValues.length);
    for (var index = 0; index < availabilityEventsValues.length; index++) {
        availabilityEvents[index] = HxAvailabilityEventData_1.deserializeHxAvailabilityEventData(availabilityEventsValues[index]);
    }
    var workingHours;
    var workingHoursPresent = values[i++];
    if (workingHoursPresent) {
        workingHours = HxWorkingHours_1.deserializeHxWorkingHours(values[i++]);
    }
    if (i != values.length) {
        throw "Result values not parsed completely";
    }
    return { smtpAddress: smtpAddress, responseCode: responseCode, responseMessage: responseMessage, availabilityEvents: availabilityEvents, workingHours: workingHours };
}
exports.deserializeHxAttendeeAvailabilityData = deserializeHxAttendeeAvailabilityData;
